import styled from 'styled-components';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const ApiNameInfoIcon = styled(InfoOutlinedIcon)`
  margin-left: 6px;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.text.secondary};
  cursor: help;
`;
